<style>
    .ag-theme-material .ag-cell {
        line-height: 35px !important;
    }
</style>

<template>
  <div id="ag-grid-demo">
    <vx-card>
      <div class="flex flex-wrap justify-between items-center">
        <div class="mb-4 md:mb-0 mr-4 ag-grid-table-actions-left"></div>
        <div class="flex flex-wrap items-center justify-between ag-grid-table-actions-right">
          <vs-button @click="refreshData" class="btn mb-4 md:mb-0 mr-1" icon="refresh">Refresh</vs-button>
          <vs-button
            @click="showAddForm = true; form = { vehicle_type: '', description: '', cap_volume: '', cap_weight: '', box_dimension: '' }"
            class="btn mb-4 md:mb-0 mr-1"
            icon="add"
          >Add</vs-button>
          <vs-button
            @click="viewData"
            class="mb-4 md:mb-0 mr-1"
            icon="remove_red_eye"
            :disabled="selectedId ? false : true"
          >View</vs-button>
          <vs-button
            class="mb-4 md:mb-0 mr-1"
            @click="removeItem"
            icon="delete"
            :disabled="selectedId ? false : true"
          >Delete</vs-button>
          <vs-button class="mb-4 md:mb-0 mr-1" @click="filterActive" icon="filter_list">Filter</vs-button>
          <vs-dropdown>
            <vs-button class="btn-drop" icon="expand_more">Spreadsheets</vs-button>
            <vs-dropdown-menu>
              <vs-dropdown-item @click="getTemplate">Template</vs-dropdown-item>
              <vs-dropdown-item @click="$refs.file.click()">Upload</vs-dropdown-item>
              <input type="file" ref="file" style="display: none" v-on:change="uploadExcel" />
              <vs-dropdown-item @click="exportExcel">Export</vs-dropdown-item>
            </vs-dropdown-menu>
          </vs-dropdown>
        </div>
      </div>
      <ag-grid-vue
        :gridOptions="gridOptions"
        class="ag-theme-material w-100 my-4 ag-grid-table"
        :columnDefs="columnDefs"
        :defaultColDef="defaultColDef"
        :rowData="vehicletypes"
        colResizeDefault="shift"
        :animateRows="false"
        :floatingFilter="false"
        rowSelection="single"
        @selection-changed="onSelectionChanged"
        @rowDoubleClicked="viewData"
      ></ag-grid-vue>
      <p class="text-right">
        <b>Showing {{ dataFrom }} to {{ dataTo }} of {{ dataTotal }} total entries</b>
      </p>
      <vs-pagination :total="totalPage" v-model="currentPage" :max="7"></vs-pagination>

      <vs-prompt buttons-hidden title="Filter" :active.sync="showFilter">
        <div class="con-exemple-prompt">
          <!-- <vs-input placeholder="Vehicle ID" v-model="filter.id" class="mt-4 mb-2 w-full" /> -->
          <vs-input
            label="Vehicle Type"
            v-model="filter.vehicle_type"
            class="mb-2 w-full"
          />
          <vs-input
            label="Description"
            v-model="filter.description"
            class="mb-2 w-full"
          />
          <vs-input label="Cap Volume" v-model="filter.cap_volume" class="mb-2 w-full" />
          <vs-input label="Cap Weight" v-model="filter.cap_weight" class="mb-2 w-full" />
          <vs-input
            label="Box Dimension"
            v-model="filter.box_dimension"
            class="mb-2 w-full"
          />
          <vs-row vs-align="flex-start" vs-type="flex" vs-justify="flex-end" vs-w="12" class="mt-5">
            <vs-button color="primary" @click="filterData">Search</vs-button>
          </vs-row>
        </div>
      </vs-prompt>

      <!-- Form view data -->
      <vs-prompt buttons-hidden title="View" :active.sync="showViewForm">
        <div class="con-exemple-prompt">
          <vs-input v-model="form.vehicle_type" class="mb-2 w-full" label="Vehicle Type *" :disabled="!editMode" />
          <vs-input
            v-model="form.description"
            class="mb-2 w-full"
            label="Description *"
            :disabled="!editMode"
          />
          <vs-input v-model="form.cap_volume" class="mb-2 w-full" label="Cap. Volume *" :disabled="!editMode" />
          <vs-input v-model="form.cap_weight" class="mb-2 w-full" label="Cap. Weight *" :disabled="!editMode" />
          <vs-input v-model="form.box_dimension" class="mb-2 w-full" label="Box Dimension *" :disabled="!editMode" />
          <vs-row vs-align="flex-start" vs-type="flex" vs-justify="flex-end" vs-w="12" class="mt-5">
            <vs-button color="primary" class="mt-2 mr-2" @click="editMode = true">Edit</vs-button>
            <vs-button color="primary" class="mt-2" @click="saveData" :disabled="!editMode">Save</vs-button>
          </vs-row>
        </div>
      </vs-prompt>

      <!-- Form add data -->
      <vs-prompt buttons-hidden title="Add" :active.sync="showAddForm">
        <div class="con-exemple-prompt">
          <vs-input v-model="form.vehicle_type" class="mb-2 w-full" label="Vehicle Type *" />
          <vs-input
            v-model="form.description"
            class="mb-2 w-full"
            label="Description *"
           
          />
          <vs-input v-model="form.cap_volume" class="mb-2 w-full" label="Cap. Volume *" />
          <vs-input v-model="form.cap_weight" class="mb-2 w-full" label="Cap. Weight *" />
          <vs-input v-model="form.box_dimension" class="mb-2 w-full" label="Box Dimension *" />
          <vs-row vs-align="flex-start" vs-type="flex" vs-justify="flex-end" vs-w="12" class="mt-5">
            <vs-button color="primary" class="mt-2" @click="addData">Save</vs-button>
          </vs-row>
        </div>
      </vs-prompt>
    </vx-card>
  </div>
</template>

<script>
import { AgGridVue } from "ag-grid-vue";
import "@/assets/scss/vuesax/extraComponents/agGridStyleOverride.scss";
import vSelect from "vue-select";
import { saveAs } from "file-saver";

export default {
  components: {
    vSelect,
    AgGridVue
  },
  data() {
    return {
      searchQuery: "",
      gridOptions: {},
      maxPageNumbers: 7,
      gridApi: null,
      vehicletypes: [],
      columnDefs: null,
      defaultColDef: {
        sortable: true,
        editable: false,
        resizable: true,
        suppressMenu: true
      },
      editMode: false,
      showViewForm: false,
      showAddForm: false,
      selectedId: null,
      isLoading: false,
      showFilter: false,
      filter: {
        id: "",
        vehicle_type: "",
        description: "",
        cap_volume: "",
        cap_weight: "",
        box_dimension: ""
      },
      form :{
        vehicle_type: '',
        description: '',
        cap_volume: '',
        cap_weight: '',
        box_dimension: ''
      },
      // Pagination
      totalPage: 0,
      currentPage: 1,
      dataFrom: 0,
      dataTo: 0,
      dataTotal: 0
    };
  },
  watch: {
    "$store.state.windowWidth"(val) {
      if (val <= 576) {
        this.maxPageNumbers = 4;
        this.gridOptions.columnApi.setColumnPinned("email", null);
      } else this.gridOptions.columnApi.setColumnPinned("email", "left");
    },
    isLoading: function() {
      if (this.isLoading) {
        this.$vs.loading();
      } else {
        this.$vs.loading.close();
      }
    },
    currentPage: function() {
      this.fetchData();
    }
  },
  methods: {
    updateSearchQuery(val) {
      this.gridApi.setQuickFilter(val);
    },
    onSelectionChanged() {
      var selectedRows = this.gridApi.getSelectedRows();
      var selectedRowsString = "";
      selectedRows.forEach(function(selectedRow, index) {
        if (index !== 0) {
          selectedRowsString += ", ";
        }
        selectedRowsString += selectedRow.id;
      });
      this.selectedId = selectedRowsString;
    },
    removeItem() {
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: "Confirm",
        text: "Are you sure want to delete this data?",
        accept: this.acceptAlert
      });
    },
    acceptAlert() {
      this.isLoading = true;
      this.$http
        .delete("master/vehicletypes/" + this.selectedId + "/destroy")
        .then(res => {
          this.$vs.notify({
            color: "success",
            title: "Success",
            iconPack: "feather",
            icon: "icon-check",
            text: "The selected data was successfully deleted."
          });
        })
        .catch(error => {
          this.$vs.notify({
            title: "Error",
            text: "Error.",
            color: "danger"
          });
        })
        .then(() => {
          this.fetchData();
        });
    },
    refreshData() {
      this.currentPage == 1 ? this.fetchData() : (this.currentPage = 1);
    },
    viewData() {
      this.isLoading = true;
      this.$http
        .get("master/vehicletypes/" + this.selectedId)
        .then(res => {
          this.editMode = false
          this.form = res.data;
          this.showViewForm = true;
        })
        .catch(error => this.handleError(error))
        .then(() => (this.isLoading = false));
    },
    addData() {
      this.isLoading = true;
      this.$http
        .post("master/vehicletypes/store", this.form)
        .then(() => {
          this.isLoading = false;
          this.showAddForm = false;
          this.$vs.notify({
            color: "success",
            title: "Success",
            iconPack: "feather",
            icon: "icon-check",
            text: "The selected data was successfully added."
          });
          this.fetchData();
        })
        .catch(error => this.handleError(error))
    },
    saveData() {
      this.isLoading = true;
      this.$http
        .put("master/vehicletypes/" + this.selectedId + "/update", this.form)
        .then(res => {
          this.isLoading = false;
          this.form = {
            name: "",
            description: ""
          };
          this.editMode = false;
          this.showViewForm = false;
          this.selectedId = null;
          this.fetchData();
          const message = res.data.message ? res.data.message : 'The selected data was successfully updated.'
          this.$vs.notify({
            color: "success",
            title: "Success",
            iconPack: "feather",
            icon: "icon-check",
            text: message
          });
        })
        .catch(error => this.handleError(error))
    },
    fetchData() {
      this.isLoading = true;
      this.$http
        .post("master/vehicletypes?page=" + this.currentPage, this.filter)
        .then(resp => {
          this.vehicletypes = resp.data.data;
          this.totalPage = resp.data.last_page;
          this.currentPage = this.currentPage;
          this.dataTotal = resp.data.total;
          this.dataFrom = resp.data.from;
          this.dataTo = resp.data.to;
          this.isLoading = false;
        })
        .catch(resp => {
          this.isLoading = false;
          this.$vs.dialog({
            type: "confirm",
            color: "danger",
            title: "Server Error",
            text: "Try again?",
            accept: () => {
              this.refreshData();
            },
            acceptText: "Yes",
            cancelText: "No"
          });
          return;
        });
    },
    filterData() {
      this.currentPage = 1;
      this.showFilter = false;
      this.fetchData();
    },
    filterActive() {
      this.showFilter = !this.showFilter;
    },
    getTemplate() {
      this.isLoading = true;
      this.$http
        .get("master/vehicletypes/report/gettemplate", {
          responseType: "blob"
        })
        .then(response => {
          this.isLoading = false;
          saveAs(response.data, "vehicle-type-upload-template.xlsx");
        });
    },
    uploadExcel() {
      let file = event.target.files[0];
      let form = new FormData();
      form.append("file", file);
      this.isLoading = true;
      this.$http
        .post("/master/vehicletypes/report/importexcel", form, {
          headers: {
            "Content-Type": "multipart/form-data"
          }
        })
        .then(resp => {
          this.isLoading = false;
          this.fetchData();
          this.$vs.notify({
            color: "success",
            title: "Upload Success",
            text: "Upload data successfully."
          });
        })
        .catch(error => this.handleError(error));
    },
    exportExcel() {
      this.isLoading = true;
      this.$http
        .post("master/vehicletypes/report/exportexcel", this.filter, {
          responseType: "blob"
        })
        .then(response => {
          this.isLoading = false;
          saveAs(response.data, "vehicle-type-list-export.xlsx");
        });
    }
  },
  mounted() {
    this.fetchData();
    this.gridApi = this.gridOptions.api;
  },
  beforeMount() {
    this.columnDefs = [
      // {
      //   headerName: "ID",
      //   field: "id",
      //   width: 100,
      //   filter: true
      // },
      {
        headerName: "Vehicle Type",
        field: "vehicle_type",
        width: 120,
      },
      {
        headerName: "Description",
        field: "description",
        width: 120
      },
      {
        headerName: "Cap. Volume",
        field: "cap_volume",
        width: 120
      },
      {
        headerName: "Cap. Weight",
        field: "cap_weight",
        width: 120
      },
      {
        headerName: "Box Dimension",
        field: "box_dimension",
        width: 120
      }
    ];
    this.gridOptions.getRowHeight = function(params) {
        return 35;
    }
  }
};
</script>